import { render, staticRenderFns } from "./InformasiKlaimPd.vue?vue&type=template&id=3fe489bf&"
import script from "./InformasiKlaimPd.vue?vue&type=script&lang=js&"
export * from "./InformasiKlaimPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports